import React, { useMemo, useState, useEffect } from 'react';
import { Typography, Grid, Button, useMediaQuery} from '@mui/material';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import swal from "sweetalert";
import config from '../../AppConfig';
import AuthUser from "../../Components/Auth/AuthUser";
import Freez from '../../Components/Loader/Loader';
import Backdrop from '@mui/material/Backdrop';
function Verification({type}) {
    const { http, getToken } = AuthUser();
    const [freez, setFreez] = React.useState(false);
    const [resendButtonDisable, setResendButtonDisable] = React.useState(false);
    const [resendCounter, setResendCounter] = React.useState(0);
    const [buttonText, setButtonText] = useState('Resend Link');
        const isMobile = useMediaQuery('(max-width:600px)');
    
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };  

    const Verification = () => {
        handleFreezStart();
        http.post("/enrollFundingSnapshotMember", {
            step:"VerifyPopup",
            aid: localStorage.getItem('SnapShot_aid'),
            userId: localStorage.getItem('UserId'),
            streetAddress1: localStorage.getItem('streetAddress'),
            streetAddress2: localStorage.getItem('streetAddress1'),
            city: localStorage.getItem('city'),
            state: localStorage.getItem('SnapShot_state'),
            mobile: localStorage.getItem('mobile'),
            dob: localStorage.getItem('dob'),
            ssn: localStorage.getItem('ssn'),
            zip: localStorage.getItem('zip'),
            firstName: localStorage.getItem('SnapShot_firstName'),
            lastName: localStorage.getItem('SnapShot_lastName'),
            email: localStorage.getItem('SnapShot_email'),
            password: localStorage.getItem('SnapShot_password'),
            source: "default",
            dtoken: localStorage.getItem('Dtoken'),
            utoken: localStorage.getItem('utoken'),
            smfaToken: localStorage.getItem('smfaToken'),
            url: config.BASE_URL,
        })
            .then((res) => {
                handleFreezStop();
                if (res.data.success === true) {
                    localStorage.setItem("ScoreData", JSON.stringify(res.data.data));
                    // Get the base URL
                    // Append "/score" to the base URL
                    const updatedUrl = config.BASE_URL + `ScoreReport/` + res.data.data.userId;
                    // Navigate to the updated URL
                    window.location.href = updatedUrl;
                } else {
                    if (res.data.data.step === "VerifyPopup") {
                        // setButtonText("Resend Link");
                        // setResendButtonDisable(false);
                        // setSentotp(res.data.data.code);
                        // handleOpenDialog();
                        alert("Oops! Encountered some error. Please try again later. \n**" + res.data.data.errorByStichCredit);
                    } else {
                        handleFreezStop();
                        swal({
                            title: "Failed",
                            text: "Oops! Encountered some error. Please try again later. \n**" + res.data.data.errorByStichCredit,
                            icon: "error",
                            button: "Ok",
                        });
                    }
                }
            })
            .catch((error) => {
                handleFreezStop();
                swal({
                    title: "Failed",
                    text: error.message,
                    icon: "error",
                    button: "Ok",
                })
            });
    }

     const resendOtp = () => {
        setResendButtonDisable(true);
        setButtonText("Processing");
        const counter = resendCounter;
        setResendCounter(counter);
        http.post("/enrollFundingSnapshotMember", {
            aid: localStorage.getItem('SnapShot_aid'),
            userId: localStorage.getItem('UserId'),
            streetAddress1: localStorage.getItem('streetAddress'),
            streetAddress2: localStorage.getItem('streetAddress1'),
            city: localStorage.getItem('city'),
            state: localStorage.getItem('SnapShot_state'),
            mobile: localStorage.getItem('mobile'),
            dob: localStorage.getItem('dob'),
            ssn: localStorage.getItem('ssn'),
            zip: localStorage.getItem('zip'),
            firstName: localStorage.getItem('SnapShot_firstName'),
            lastName: localStorage.getItem('SnapShot_lastName'),
            email: localStorage.getItem('SnapShot_email'),
            password: localStorage.getItem('SnapShot_password'),
            counter: counter,
            type: type ? type : "phone",
        })
            .then((res) => {
                if (res.data.success === true) {
                    localStorage.setItem('Dtoken', res.data.data.dtoken);
                    localStorage.setItem('rtoken', res.data.data.rtoken);
                    localStorage.setItem('paToken', res.data.data.paToken);
                    localStorage.setItem('UserId', res.data.data.userId);
                    localStorage.setItem("smfaToken", res.data.data.smfaToken);
                    localStorage.setItem("utoken", res.data.data.utoken);
                    alert("Link Resent Successfully");
                } else {
                    alert("Link Resent Failed");
                }
                setButtonText("Resend Link");
                setResendButtonDisable(false);
            })
            .catch((error) => {
                setButtonText("Resend Link");
                setResendButtonDisable(false);
                handleFreezStop();
                swal({
                    title: "Failed",
                    text: error.message,
                    icon: "error",
                    button: "Ok",
                })
            });
        }
    
    return (
        <>
            <Grid container item lg={12} md={12} sm={12} xs={12} mb={2}>
                <Typography varient="body1" textAlign="center"><b>
                    You Should Have Received{" "}
                            {type === "phone" ? (
                                <>
                               A Text Message On Your{" "}
                                <span style={{ textTransform: "capitalize" }}>{type}</span>
                                </>
                            ) : (
                                <>
                                An <span style={{ textTransform: "capitalize" }}>{type}</span> On Your Registered Email ID
                                </>
                            )}{" "}
                         Containing An Authentication Link To Verify Your Identity. Please Click The Link To Complete The Authentication Process. Once Authenticated, Click The "Next" Button Below To Proceed To Your Funding Snapshot.
                    </b>
                </Typography>
            </Grid>
            <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                <img src={require("../../assets/images/verificationPhone.png")} // update path
                    alt="Business meeting"
                    style={{ width: "150px", height: "100%", objectFit: "cover" }} />
            </Grid>
            <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mt={2}>
                <Button variant="contained" color="success" 
                id="step2NextButton"
                name="step2NextButton" 
                onClick={Verification}
                    sx={{
                        backgroundColor: "#3FAC19",
                        minWidth: isMobile?"200px":"300px",
                        fontSize: "16px",
                        fontWeight:700,
                        borderRadius: "10px",
                        animation: "blink 1.5s infinite",
                        "@keyframes blink": {
                            "0%": { backgroundColor: "#3FAC19" }, 
                            "50%": { backgroundColor: "#55cc28" }, 
                            "100%": { backgroundColor: "#3FAC19" },
                        },
                    }}>NEXT</Button>
            </Grid>
            <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mt={1} mb={2}>
                <Typography>Haven't Received The Authorization Link Yet?</Typography>&nbsp;&nbsp;
                 <Button id="resendOtp" name="resendOtp" disabled={resendButtonDisable} onClick={resendOtp} color="primary" size='small' variant="contained" sx={{ color: "white" }}>{buttonText}</Button>
               
            </Grid>

            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                >
                    <Freez />
                </Backdrop>
            </div>
        </>
    );
}





export default Verification;